<script>
    let darkMode = false;
  
    // Toggle function to switch between dark and light modes
    function toggleDarkMode() {
      darkMode = !darkMode;
      if (darkMode) {
        document.body.setAttribute("data-bs-theme", "dark"); // Add data-bs-theme attribute
      } else {
        document.body.removeAttribute("data-bs-theme"); // Remove data-bs-theme attribute
      }
      console.log("Dark mode:", darkMode);
    }
  </script>
  
  <div id="darkmode">
    <div class="bottom">
      <!-- Toggle dark mode on click -->
      <!-- svelte-ignore a11y-invalid-attribute -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <a on:click={toggleDarkMode} id="mode" class="mode-btn text-black">
        <!-- Icons for light and dark mode -->
        <i class="mdi mdi-white-balance-sunny mode-light align-middle"></i>
        <i class="mdi mdi-weather-sunny mode-dark align-middle"></i>
      </a>
    </div>
  </div>